// API_BASE is empty so requests use relative paths (/api/...) and go through
// the Vite dev proxy, avoiding CORS issues entirely.
export const API_BASE = import.meta.env.VITE_API_BASE ?? ''

// WebSocket URL derived from current page origin so it also goes through the proxy.
const _wsProto = typeof window !== 'undefined' && window.location.protocol === 'https:' ? 'wss:' : 'ws:'
const _wsHost = typeof window !== 'undefined' ? window.location.host : 'localhost:5173'
export const WS_URL = import.meta.env.VITE_WS_URL ?? `${_wsProto}//${_wsHost}/ws`

export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL ?? 'http://localhost:54321'
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY ?? ''
export const DEV_MODE = import.meta.env.DEV
